import { render, staticRenderFns } from "./AppointmentRequests.vue?vue&type=template&id=2d0f4b6a&scoped=true&"
import script from "./AppointmentRequests.vue?vue&type=script&lang=js&"
export * from "./AppointmentRequests.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentRequests.vue?vue&type=style&index=0&id=2d0f4b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f4b6a",
  null
  
)

export default component.exports